<template>
  <div id="area-base-component">
    <div class="d-flex justify-end mb-3">
      <v-row v-if="isFreeOffer" align="center">
        <v-col cols="3">무료 제공 시간</v-col>
        <div class="d-inline-block defaultValue">
          <v-text-field v-model="freeMinutes" :rules="[rules.numberOnly]" :disabled="!inputState"></v-text-field>
        </div>
        분
      </v-row>
      <c-btn outlined color="blue" @click="addAreaTime" :disabled="!inputState"> 구간추가</c-btn>
    </div>
    <div v-for="(fare, index) in fareList" v-if="index > 0">
      <c-card outlined  :title="index + '구간'" class="mt-4">
        <template #headItems>
          <c-btn v-if="index>1" icon iconName="close" @click="deleteAreaTime" :disabled="!inputState"></c-btn>
        </template>
        <v-row align="center">
          <v-col sm="3" md="2">구간 범위</v-col>
          <div class="extraValue">
            <div>
              <v-text-field v-model="fare.startValue = fareList[index-1].endValue" :rules="[rules.numberOnly]" :disabled="!inputState"/>
            </div>
          </div> 분 이상
          <div class="extraValue ml-5">
            <v-text-field v-model="fare.endValue = index === fareList.length-1 ? null : fare.endValue" :disabled="(index === fareList.length-1) || !inputState"
                          :rules="[rules.numberOnly, rules.greaterNumber]"/>
          </div> 분 미만
        </v-row>
        <v-row align="center">
          <v-col sm="3" md="2">기본 요금</v-col>
          <v-col sm="9" md="10">
            <v-text-field v-model="fare.unitFare" :rules="[rules.numberOnly]" class="areaUnitValue" dense :disabled="!inputState"></v-text-field> 원
          </v-col>
        </v-row>
      </c-card>
    </div>

  </div>
</template>

<script>
export default {
  name: "AreaTimeBase",
  props: {
    isFreeOffer: {
      //무료제공시간 존재여부
      type: Boolean,
      default: false,
    },
    fareInfo: {
      type: Object,
      default: []
    },
    inputState: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      freeMinutes:null,
      fareList: [
        {startValue: 0, endValue: null, unitValue: 1, unitFare: 0, area: '', areaDescription:''},
        {startValue: null, endValue: null, unitValue: 1, unitFare: null, area: '', areaDescription: ''}
  ],
      rules: {
        numberOnly: value => /^[0-9]*$|^null$/.test(value) || '숫자만 입력해주세요',
        greaterNumber: value => this.isGreaterNumber(value) || '시작 시간보다 큰 시간이어야 합니다'
      }
    }
  },
  watch: {
    freeMinutes(value) {
      this.fareList[0].endValue = value;
    },
    fareInfo: {
      deep: true,
      handler(value) {
        if(value.length > 0) {
          this.freeMinutes = this.isFreeOffer ? value[0].endValue : null;
          this.fareList = value;
        }
      }
    },
    fareList: {
      deep: true,
      handler(value) {
        value[0]['unitValue'] = value[0].endValue
        this.$emit('update:fareInfo', value)
      }
    },
  },
  methods: {
    addAreaTime() {
      const len = this.fareList.length;

      this.fareList.push({
        unitFare:0, areaDescription: '', area: '', startValue: this.fareList[len-1].endValue, endValue: null, unitValue: 1,
      })
    },
    deleteAreaTime() {
      this.fareList.splice(this.fareList.length-1, 1);
    },
    isGreaterNumber(cur) {
      cur = Number(cur)
      return typeof this.fareList.find(item => Number(item.endValue) === cur && Number(item.startValue) >= Number(item.endValue)) === 'undefined';
    }
  },
}
</script>

<style scoped>
.extraValue {
  width: 110px;
  margin-left: 12px;
}

.areaUnitValue{
  display: inline-block;
  width: 150px
}

</style>
